const EsignEnvelopeStatus = Object.freeze({
    DRAFT: 'DRAFT',
    CREATED: 'CREATED',
    SENT: 'SENT',
    IN_PROGRESS: 'IN_PROGRESS',
    DECLINED: 'DECLINED',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
    SIGNED: 'SIGNED'
});

export default EsignEnvelopeStatus;
